// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dTS7","rootNoMargin":"styles_rootNoMargin__1AShN"};